const SOLUTION_SHOP = {
    SOLUTION_SHOP_ICON: {
        event: 'Solution Shop Icon Click',
        eventProperties: {
            description: 'User clicked on solution shop icon on dashboard',
        },
    },
    CORE_PRODUCTS: {
        LEARN_MORE: {
            SMART_EMPLOYEE_HANDBOOK_PLUS: {
                event: 'Smart Employee Handbook Plus Learn More Button Click',
                eventProperties: {
                    description:
                        'User clicked on Smart Employee Handbook Plus Learn More button in solution shop',
                },
            },
            WHP: {
                event: 'Workplace Harassment Prevention Learn More Button Click',
                eventProperties: {
                    description:
                        'User clicked on Workplace Harassment Prevention Learn More button in solution shop',
                },
            },
            GHRC: {
                event: 'Guided HR Compliance (GHRC) Learn More Button Click',
                eventProperties: {
                    description:
                        'User clicked on Guided HR Compliance (GHRC) Learn More button in solution shop',
                },
            },
            LEARN_CATALOGS: {
                event: 'Learn Catalogs Learn More Button Click',
                eventProperties: {
                    description:
                        'User clicked on Learn Catalogs Learn More button in solution shop',
                },
            },
            ACA: {
                event: 'ACA Learn More Button Click',
                eventProperties: {
                    description: 'User clicked on ACA Learn More button in solution shop',
                },
            },
        },
        USE_NOW: {
            SMART_EMPLOYEE_HANDBOOK_PLUS: {
                event: 'Smart Employee Handbook Plus Use Now Button Click',
                eventProperties: {
                    description:
                        'User clicked on Smart Employee Handbook Plus Use Now button in solution shop',
                },
            },
            WHP: {
                event: 'Workplace Harassment Prevention Use Now Button Click',
                eventProperties: {
                    description:
                        'User clicked on Workplace Harassment Prevention Use Now button in solution shop',
                },
            },
            GHRC: {
                event: 'Guided HR Compliance (GHRC) Use Now Button Click',
                eventProperties: {
                    description:
                        'User clicked on Guided HR Compliance (GHRC) Use Now button in solution shop',
                },
            },
            LEARN_CATALOGS: {
                event: 'Learn Catalogs Use Now Button Click',
                eventProperties: {
                    description: 'User clicked on Learn Catalogs Use Now button in solution shop',
                },
            },
            ANONYMOUS_REPORTING: {
                event: 'Anonymous Reporting Use Now Button Click',
                eventProperties: {
                    description:
                        'User clicked on Anonymous Reporting Use Now button in solution shop',
                },
            },
            ACA: {
                event: 'ACA Use Now Button Click',
                eventProperties: {
                    description: 'User clicked on ACA Use Now button in solution shop',
                },
            },
        },
        REQUEST_PRICING: {
            GHRC: {
                event: 'Guided HR Compliance (GHRC) Request Pricing Button Click',
                eventProperties: {
                    description:
                        'User clicked on Guided HR Compliance (GHRC) Request Pricing button in solution shop',
                },
            },
            LEARN_CATALOGS: {
                event: 'Learn Catalogs Request Pricing Button Click',
                eventProperties: {
                    description:
                        'User clicked on Learn Catalogs Request Pricing button in solution shop',
                },
            },
            ACA: {
                event: 'ACA Request Pricing Button Click',
                eventProperties: {
                    description: 'User clicked on ACA Request Pricing button in solution shop',
                },
            },
        },
    },
    ADDITION_PRODUCTS: {
        LEARN_MORE: {
            ASSURE_HIRE: {
                event: 'Background Screening Learn More Button Click',
                eventProperties: {
                    description:
                        'User clicked on Background Screening Learn More button in solution shop',
                },
            },
            TRAKSTAR_PERFORM: {
                event: 'Performance Management Learn More Button Click',
                eventProperties: {
                    description:
                        'User clicked on Performance Management Learn More button in solution shop',
                },
            },
            TRACKER_I9: {
                event: 'I-9 Compliance Learn More Button Click',
                eventProperties: {
                    description:
                        'User clicked on I-9 Compliance Learn More button in solution shop',
                },
            },
        },
        USE_NOW: {
            ASSURE_HIRE: {
                event: 'Background Screening Use Now Button Click',
                eventProperties: {
                    description:
                        'User clicked on Background Screening Use Now button in solution shop',
                },
            },
            TRAKSTAR_PERFORM: {
                event: 'Performance Management Use Now Button Click',
                eventProperties: {
                    description:
                        'User clicked on Performance Management Use Now button in solution shop',
                },
            },
            TRACKER_I9: {
                event: 'I-9 Compliance Use Now Button Click',
                eventProperties: {
                    description: 'User clicked on I-9 Compliance Use Now button in solution shop',
                },
            },
        },
        REQUEST_PRICING: {
            ASSURE_HIRE: {
                event: 'Background Screening Request Pricing Button Click',
                eventProperties: {
                    description:
                        'User clicked on Background Screening Request Pricing button in solution shop',
                },
            },
            TRAKSTAR_PERFORM: {
                event: 'Performance Management Request Pricing Button Click',
                eventProperties: {
                    description:
                        'User clicked on Performance Management Request Pricing button in solution shop',
                },
            },
            TRACKER_I9: {
                event: 'I-9 Compliance Request Pricing Button Click',
                eventProperties: {
                    description:
                        'User clicked on I-9 Compliance Request Pricing button in solution shop',
                },
            },
        },
    },
};

export default SOLUTION_SHOP;
